import { UIElement } from "../../common_ui_elements/ui_element.js";

export class FeedbackScreen extends UIElement
{

  public render(): void
  {
    if ( !this.shouldBeRendered() )
      return;
    this.startRender();
    this.finishRender();
  }

  public name (): string
  {
    return "FeedbackScreen";
  }
}